import { type NodeProps, Text, View } from '@react-pdf/renderer';

import { usePDFContext } from '../../../PDFProvider';
import { styles } from '../styles';

export function CustomerAddress({
  children,
  nameStyle,
}: {
  children?: React.ReactNode;
  nameStyle?: NodeProps['style'];
}) {
  const { customer } = usePDFContext();
  const { name, address1, address2, city, state, postalCode, countryCode } =
    customer;

  return (
    <View style={styles.section}>
      <Text style={nameStyle}>{name}</Text>
      {address1 ? <Text>{address1}</Text> : null}
      {address2 ? <Text>{address2}</Text> : null}

      {city && state && postalCode ? (
        <Text>
          {city}, {state} {postalCode}
        </Text>
      ) : null}

      {countryCode ? <Text>{countryCode}</Text> : null}
      {children}
    </View>
  );
}
